import useResources from "./use-resources";
import type { PriorityAction } from "../models/priorityAction";

export interface SnoozeValues {
  remind_at: string | null;
  remind_by_mail: boolean;
}

export default function usePriorityActions(
  options: { archived?: boolean } = {},
) {
  const { resources, create, update, del, mutate, isLoading, error } =
    useResources<PriorityAction>("priority-actions", {
      params: { status: options.archived ? "archived" : "active" },
    });

  function snoozeAction(actionId: number, values: SnoozeValues) {
    return update(actionId, values);
  }

  function archiveAction(actionId: number) {
    return del(actionId);
  }

  function restoreAction(actionId: number) {
    return update(actionId, { status: "active" });
  }

  return {
    actions: resources,
    createAction: create,
    snoozeAction,
    archiveAction,
    restoreAction,
    mutate,
    isLoading,
    error,
  };
}
